import { styled } from '@material-ui/core';
import { Wrapper as WrapperFormInput } from 'src/components/common/formInput/styles';

export const Wrapper = styled(WrapperFormInput)({
  display: 'block'
});